import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Forward, IndexRedirect } from "./components/redirects";
import { AgentPage } from "./pages/AgentPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { BoardPage } from "./pages/BoardPage";
import { CalendarPage } from "./pages/CalendarPage";
import { ChoosePage } from "./pages/ChoosePage";
import { ClipPage } from "./pages/ClipPage";
import { JobsPage } from "./pages/JobsPage";
import { JoinPage } from "./pages/JoinPage";
import { LoginPage } from "./pages/LoginPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { RenderPage } from "./pages/RenderPage";
import { RoleBriefPage } from "./pages/RoleBriefPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SongPage } from "./pages/SongPage";
import { Stub } from "./pages/Stub";
import { TikTokAnalyticsPage } from "./pages/TikTokAnalyticsPage";
import { WatchPage } from "./pages/WatchPage";

/** Route table (spine-owned). Pages are owned by WS7 (board, song, jobs, settings, calendar, analytics, agent,
 * notifications) and WS8 (watch, clip, choose, render); they replace their page files, not this table. */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/join" element={<JoinPage />} />
      <Route element={<Layout />}>
        <Route index element={<IndexRedirect />} />
        <Route path="/renders" element={<Forward to="/board/renders" />} />
        <Route path="/clips" element={<Forward to="/board/videos" />} />
        <Route path="/board/:group" element={<BoardPage />} />
        <Route path="/songs/:songId" element={<SongPage />} />
        <Route path="/watch/:videoId" element={<WatchPage />} />
        <Route path="/clips/:clipId" element={<ClipPage />} />
        <Route path="/choose" element={<ChoosePage />} />
        <Route path="/renders/:renderId" element={<RenderPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/tiktok" element={<TikTokAnalyticsPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/agent" element={<AgentPage />} />
        <Route path="/agent/:role" element={<RoleBriefPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="*" element={<Stub title="Not found" owner="nobody" />} />
      </Route>
    </Routes>
  );
}
